export default __webpack_public_path__ + "static/media/INDISCHES RESTAURANT GANESHA HOME.2de63509.jpg";